import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ValorisezVotreMarque() {
  useRevealOnScroll();
  const openAppStore = () => {
    window.open("https://apps.apple.com/us/app/barndesk/id6768716555", "_blank", "noopener,noreferrer");
  };
  const openGooglePlay = () => {
    window.open("https://play.google.com/store/apps/details?id=com.barndesk.app", "_blank", "noopener,noreferrer");
  };
  return <section data-section-id="hero" className="relative overflow-hidden bg-background pt-20 pb-16 md:pt-28 md:pb-24">
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-gradient-to-b from-chart-2/10 via-background to-background"></div>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="reveal-on-scroll text-center lg:text-left">
            <p className="inline-flex items-center gap-2 text-sm font-medium text-chart-2 mb-4">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-chart-2"></span>
              Built by a Farmer, for Farmers.
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.1]">
              Less paperwork.
              <br />
              <span className="text-primary">More pasture.</span>
            </h1>
            <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-xl mx-auto lg:mx-0 leading-relaxed">
              BarnDesk keeps your animals, breeding and pedigree records, chores, receipts, equipment, and the Schedule F and USDA paperwork in one place. Built for mixed-livestock family farms.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 items-center justify-center lg:justify-start">
              <button type="button" onClick={openAppStore} className="inline-flex items-center gap-3 h-12 px-5 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity">
                <span className="flex flex-col items-start leading-tight">
                  <span className="text-[10px] uppercase tracking-wide opacity-80">Download on the</span>
                  <span className="text-base font-semibold">App Store</span>
                </span>
              </button>
              <button type="button" onClick={openGooglePlay} className="inline-flex items-center gap-3 h-12 px-5 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity">
                <span className="flex flex-col items-start leading-tight">
                  <span className="text-[10px] uppercase tracking-wide opacity-80">Get it on</span>
                  <span className="text-base font-semibold">Google Play</span>
                </span>
              </button>
            </div>
            <p className="mt-4 text-sm text-muted-foreground">
              Free for up to 10 animals. No credit card to start.
            </p>
            <p className="mt-3 text-sm text-muted-foreground">
              Or open BarnDesk right in your browser — now on your computer too.{" "}
              <Link to="https://app.thebarndesk.com" newTab className="font-medium text-primary hover:underline whitespace-nowrap">
                Open the web app →
              </Link>
            </p>
          </div>
          <div className="reveal-on-scroll relative flex items-center justify-center min-h-[480px] lg:min-h-[560px]">
            <div aria-hidden="true" className="absolute inset-0 -z-10 blur-3xl opacity-40 bg-gradient-to-br from-chart-2/30 to-primary/20 rounded-full"></div>
            <div className="relative w-full max-w-md h-[480px] lg:h-[560px]">
              <img src="https://thebarndesk.com/wp-content/uploads/2026/05/schedule-F-scaled.png" alt="BarnDesk Schedule F tax categories screen" className="absolute top-8 left-2 w-[42%] object-contain drop-shadow-2xl rounded-2xl rotate-[-10deg] z-10" />
              <img src="https://thebarndesk.com/wp-content/uploads/2026/05/today-screen-main.png" alt="BarnDesk Today screen showing chores, animal alerts, and Schedule F totals" className="absolute top-0 left-1/2 -translate-x-1/2 w-[46%] object-contain drop-shadow-2xl rounded-2xl z-20" />
              <img src="https://thebarndesk.com/wp-content/uploads/2026/05/animal-detail-screen-scaled.png" alt="BarnDesk animal detail screen with health and breeding records" className="absolute top-8 right-2 w-[42%] object-contain drop-shadow-2xl rounded-2xl rotate-[10deg] z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}